<template>
  <div class="status" :gutter="12"  >
    <el-row>
      <el-col :span="8" ><div style="width: 70px;overflow: hidden;">{{statusType.name+' : '}}</div></el-col>
      <el-col :span="10" class="item">
        <div class="pot" :class="{normal:statusType.type == 0}" ></div>
        <div class="pot" :class="{rate: statusType.type == 1}"></div>
        <div class="pot" :class="{warning:statusType.type == 2}" ></div>
      </el-col>
    </el-row>
  </div> 
</template>

<script>
export default {
  props:['statusType'],
}
</script>

<style scoped>
.status{
  font-size: 14px;
  /* font-weight: 600; */
  width: 100%;
  margin-bottom: 3px;
  /* background: lightcoral; */
  
}
.item{
  padding-top:2px ;
  height: 14px;
  line-height: 14px;
  width: 80px;
  overflow: hidden;
}
.pot{
  position: relative;
  margin: 0 8px;
  width: 8px;
  height: 8px;
  border-radius: 4px;
  /* background: #666; */
  background-color: #ebeef5;
  display: inline-block;
}
/* .light{
  position: relative;
  list-style: none;
  width: 6px;
  margin: 0 10px;
  border-radius: 3px;
  color: #666;
  display: inline-block;
} */
.normal{
  background-color: #13ce66;
}
.rate{
  background-color: #fcad2c;
}
.warning{
  background-color: #F56C6C;
}

</style>